const start_video = () => {
  setTimeout(() => {
    $("body").on("mouseover", "video", function () {
      this.play();
    });
    $("body").on("mouseleave", "video", function () {
      this.pause();
    });
  }, 100);
};

export default start_video;
